import * as React from 'react'
import { connect } from 'react-redux'

import { ProAdvert } from 'components/generic'
import { Home } from '@lmc/ts-common'
import CQIReportComponent, { CQIReportProps } from './CQIReportComponent'

interface StateProps {
  preferredPeopleNominative: string
  carePlansNominative: string
  home?: Home
}

interface DispatchProps {
  fetchData?: () => Promise<void>
}

type CQIReportScreenProps = StateProps & DispatchProps

export function CQIReportScreen({
  home,
}: CQIReportScreenProps): React.ReactElement {
  if (!home?.features?.cqi?.enabled) {
    return <ProAdvert />
  }

  return <CQIReportComponent />
}

const mapStateToProps = (state: any) => {
  return {
    preferredPeopleNominative: state.global.home.preferredPeopleNominative,
    carePlansNominative: state.global.home.preferredCarePlansNominative,
    home: state.global.home,
  }
}

export default connect<StateProps, DispatchProps, CQIReportProps>(
  mapStateToProps
)(CQIReportScreen)
